module.exports = __webpack_public_path__ + "img/hb-active.bb42b11f.svg";